import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { BillingDetailsContainer } from "../BillingDetailsContainer";
import { APIUsageDetails } from "./APIUsageDetails";
import { AiActionsUsageDetails } from "./AiActionsUsageDetails";
import { CommunityUsageDetails } from "./CommunityUsageDetails";
import { EmailHubUsageDetails } from "./EmailHubUsageDetails";

export const UsageDetails = () => (
  <BillingDetailsContainer>
    <div className="flex flex-col gap-y-6">
      <div>
        <Typography.LabelLg weight="semibold">
          {t("settings.billing.manage_billing.usage_details.title")}
        </Typography.LabelLg>
      </div>
      <CommunityUsageDetails />
      <EmailHubUsageDetails />
      <AiActionsUsageDetails />
      <APIUsageDetails />
    </div>
  </BillingDetailsContainer>
);
